// Default noise filters applied to every Sentry init in this monorepo.
// These errors are not actionable: they originate from browser quirks,
// extensions, or normal lifecycle events that React/the SDK can't avoid.
export const DEFAULT_IGNORE_ERRORS: (string | RegExp)[] = [
  // Chrome ResizeObserver quirk — fires when layout takes >1 frame; harmless.
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
  // Promise rejection without an Error object — usually third-party SDKs.
  "Non-Error promise rejection captured",
  // Browser extension noise (cannot affect from our code).
  /^Extension context invalidated/,
  /chrome-extension:\/\//,
  /moz-extension:\/\//,
  // Safari/iOS network glitches (user navigated away, connection cancelled).
  "Load failed",
  "AbortError",
];
